import React, { useEffect, useState, useContext } from "react";
import { GlobalContextType } from "../../../../@types/global";
import BackHeader from "../../../../components/BackHeader/BackHeader";
import { GlobalContext } from "../../../../context/globalContext";
import {
  Card,
  Typography,
  Select,
  message,
  Spin,
  Collapse,
} from "antd";

const { Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

interface Pontuacao {
  _id: string;
  tipo: string;
  chave: string;
  nota: number;
}

const notaOptions = [
  { value: 0.25, label: "Baixo", color: "green" },
  { value: 0.5, label: "Médio", color: "orange" },
  { value: 0.75, label: "Alto", color: "red" },
  { value: 1, label: "Extremamente Alto", color: "#8B0000" },
];

const getNotaStyle = (value: number) => {
  const match = notaOptions.find((opt) => opt.value === value);
  return match ? { color: match.color, fontWeight: "bold" } : {};
};

const GerenciarRiscos = () => {
  const { moduloMapeamento, userInfo } = useContext(
    GlobalContext
  ) as GlobalContextType;
  const [pontuacoes, setPontuacoes] = useState<Pontuacao[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchPontuacoes = async () => {
    moduloMapeamento
      .fetchPontuacoes()
      .then((data) => setPontuacoes(data))
      .finally(() => setLoading(false));
  };

  const handleNotaChange = async (id: string, nota: number) => {
    moduloMapeamento
      .handleNotaChange(id, nota)
      .then(() =>
        setPontuacoes((prev) =>
          prev.map((item) => (item._id === id ? { ...item, nota } : item))
        )
      );
  };

  useEffect(() => {
    if (userInfo._id) {
      fetchPontuacoes();
    }
  }, [userInfo]);

  // Agrupar por tipo
  const pontuacoesPorTipo = pontuacoes.reduce<Record<string, Pontuacao[]>>(
    (acc, item) => {
      if (!acc[item.tipo]) acc[item.tipo] = [];
      acc[item.tipo].push(item);
      return acc;
    },
    {}
  );

  return (
    <div className="p-4">
      <BackHeader title="Gerenciar riscos" prev />
      {loading ? (
        <Spin tip="Carregando..." />
      ) : (
        <Collapse accordion>
          {Object.entries(pontuacoesPorTipo).map(([tipo, itens]) => (
            <Panel header={tipo} key={tipo}>
              {itens.map((item) => (
                <Card key={item._id} className="mb-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <Text strong>{item.chave}</Text>
                      <br />
                      <Text style={getNotaStyle(item.nota)}>
                        {
                          notaOptions.find((opt) => opt.value === item.nota)
                            ?.label || "Desconhecido"
                        }
                      </Text>
                    </div>
                    <Select
                      value={item.nota}
                      onChange={(value) => handleNotaChange(item._id, value)}
                      style={{ width: 200 }}
                    >
                      {notaOptions.map((opt) => (
                        <Option
                          key={opt.value}
                          value={opt.value}
                          style={{ color: opt.color }}
                        >
                          {opt.label}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Card>
              ))}
            </Panel>
          ))}
        </Collapse>
      )}
    </div>
  );
};

export default GerenciarRiscos;
